import { ErrorMessage, Field, Form, Formik } from "formik";
import { CaretLeft } from "@phosphor-icons/react";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useAuth } from "../../context/AuthContext";
import useFundWallet from "../../hooks/useFundWallet";
import { HashLoader } from "react-spinners";
import LinkedCard from "../../components/LinkedCard";
import { toast } from "sonner";
import CurrencyInput from "../../components/CurrencyInput";
import { leaveSetupTask } from "../../utils/setupTaskReturn";

const schema = yup.object().shape({
  amount: yup
    .number()
    .min(50, "The minimum amount you can fund is 50 NGN.")
    .max(500_000, "The maximum amount you can fund is 500,000 NGN.")
    .required("Please enter an amount to fund your wallet."),
});

const FundWithCard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { refetch } = useAuth();

  const {
    fundWallet,
    fundingWallet,
    fundingWalletError,
    isFundingWalletError,
  } = useFundWallet({
    onSuccess() {
      refetch();
      toast.success("Wallet Funded Successfully");
      // Funding started from a checkout goes straight back to it.
      leaveSetupTask(navigate, location.state);
    },
    onError() {
      toast.error("An error occurred while funding wallet");
    },
  });
  return (
    <div>
      {fundingWallet && (
        <div className="fixed top-0 z-50 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
          <HashLoader />
        </div>
      )}
      <div className="flex items-center justify-center gap-10 px-5 py-20 text-center flex-col">
        <div className="flex flex-col gap-2">
          <div className="font-semibold text-3xl">
            How much would you like to fund?
          </div>
        </div>
        <Formik
          initialValues={{
            amount: "",
          }}
          validationSchema={schema}
          onSubmit={(values, { resetForm }) => {
            fundWallet(values, {
              onSuccess() {
                resetForm();
              },
            });
          }}
        >
          {({ isValid, dirty }) => {
            return (
              <Form className="flex-col gap-5 flex items-start justify-center w-full max-w-[24rem]">
                <LinkedCard />
                <div className="flex flex-col gap-2 w-full items-start">
                  <div className="flex gap-2 w-full justify-between items-center bg-red">
                    <label
                      htmlFor="amount"
                      className="text-sm font-bold text-gray-700"
                    >
                      Amount*
                    </label>
                  </div>
                  <Field
                    name="amount"
                    component={CurrencyInput}
                    placeholder="Enter amount"
                    id="amount"
                    className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                  />
                  <ErrorMessage
                    name="amount"
                    component="div"
                    className="text-red-500 text-left"
                  />
                  <div className="text-gray-500 text-sm">
                    ₦ 50 - ₦ 500,000
                  </div>
                </div>
                {isFundingWalletError && (
                  <div className="text-red-500">
                    {fundingWalletError?.message}
                  </div>
                )}
                <div className="flex justify-between w-full gap-2">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="p-2 py-3 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300"
                  >
                    <CaretLeft weight="bold" size={20} />
                    <span>Back</span>
                  </button>

                  <button
                    disabled={!isValid || !dirty}
                    type="submit"
                    className="p-2 py-3 text-center flex-1 bg-deepBlue text-white px-10 border-2 border-deepBlue rounded-xl font-medium w-full"
                  >
                    Pay
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default FundWithCard;
